import React from 'react'
import Contact from './Contact'

const ContactPage = () => {
  return (
        <div style={{ paddingTop : '10vw'}}><Contact/></div>
  )
}

export default ContactPage